import * as React from 'react'

export const ConfigurationContext = React.createContext({})
export const Provider = ConfigurationContext.Provider
